import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import DeviceSummaryCard from '../Cards/DeviceSummaryCard';
function DeviceSummaryView(props) {
    const { userCustomers } = props;
    return userCustomers ? _jsx(DeviceSummaryCard, { ...props }) : _jsx(_Fragment, {});
}
export default DeviceSummaryView;
